import * as React from 'react';
import * as ReactDom from 'react-dom';
import { useContext, useReducer, useState, useEffect } from "react";
import { MessagesContext } from "../common/context";

//import { graph } from '@pnp/graph';
//import { MSGraphClient } from '@microsoft/sp-http';
//import { WebPartContext } from "@microsoft/sp-webpart-base";

import { escape } from '@microsoft/sp-lodash-subset';
import * as Fabric from 'office-ui-fabric-react';
import { Link, initializeIcons, ActivityItem, Icon } from 'office-ui-fabric-react';
import { CommandBar, ICommandBarItemProps } from 'office-ui-fabric-react/lib/CommandBar';
import { DirectionalHint } from 'office-ui-fabric-react/lib/Callout';
import { ChatMessagesContainer } from '../chatMessage/ChatMessagesContainer';
import { getChatMessagesAndDispatch } from "../../model/chatMessageService";
import  * as uuidv4 from "uuid/v4";
import log from 'loglevel';
import { chatStyle, classNames } from "./Chat.Styles";
import { PIVOT_KEY } from "../common/consts";

/**
 * @Chat - Represents one chat thread
 * 
 * @param - chatId
 * @param - chat and obeject representing the chat content as extracted in chat container
 * @param - accessToken
 * 
 */
export const Chat = ({ chatId, chat, accessToken}) => {

  const { dispatch, state } = useContext(MessagesContext);
  const [isChecked, setIsChecked] = useState(false);
  const [showChatMessages, setShowChatMessages] = useState(false);  
  const [pageNumber, setPageNumber] = useState(1);
  log.info(`@Chat`);


  useEffect(() => {
    log.info(`useEffect @ Chat`);
    if ( isChecked ) 
    {
      try {          

        getChatMessagesAndDispatch(chatId, accessToken, dispatch);
        const ___payload = { pivotKey:  PIVOT_KEY.ITEMS};
        dispatch({ type: "SET_PIVOT_KEY", payload: ___payload })
        
    } catch (error) {
        log.error(`error / useEffect @ Chat: ${JSON.stringify(Error)}`);          
    } finally {
        log.info(`finally / useEffect @ Chat`);
    }

    }
    }, [isChecked]);



  const toggleShowChatMessages = ()=>{
    log.info(`toggleShowChatMessages @ Chat`);
    setShowChatMessages(prevState=>(!prevState.setShowChatMessages));
  };
  
  const handleToItemsM = ()=>{
    log.info(`handleToItemsM @ Chat`);
    setIsChecked(prevState=>(!prevState.isChecked)); 
  }


  // Initialize icons in case this example uses them
  initializeIcons();

  const nextPage = () =>{
    log.info(`nextPage @ Chat`); 
    setPageNumber(pageNumber + 1);
  };

  const previousPage = () =>{
    log.info(`previousPage @ Chat`); 
    const _pageNumber = pageNumber == 1 ? pageNumber : pageNumber -1;
    setPageNumber(_pageNumber);
  };  

  const handleChatWebUrl = ()=>{
    log.info(`handleChatWebUrl @ Chat`);
    //window.open(team.webUrl, '_blank')
  };


  const activityItemExamples = [
    {
      key: 1,
      activityDescription: [
        <span key={1}>{`[Chat:] ${chat.displayName}`} </span>,
        <Link
        key={2}
        
        className={classNames.nameText}
        onClick={() => {
          toggleShowChatMessages();
        }}
      > 
         <Icon iconName={''} />
         <Icon iconName={'Message'} /> Channels
      </Link>

      ],
      activityIcon: <Icon iconName={'Message'} />
    }
  ];


        const _items = [
      {
        key: 'open',
        iconProps: { iconName: 'TeamFavorite' }
        // onClick: () => {
        //   handleTeamWebUrl(); // needs further exploration to get the actual url
        // }
      },
      {
        key: 'share',
        text: `[Chat:] ${chat.displayName}`,
       // onClick: () => {handleClick()}
      }

    ];

    const _farItems = [
      {
        key: 'toItemsM',
        text: 'Copy ChatMessages to Items',
        iconOnly: true,
        iconProps: { iconName: 'Copy' },
        onClick:  ()=>{ handleToItemsM(); } 
      },
      // paging is not supported yet with this api
      // {
      //   key: 'previousPage',
      //   text: 'Previous Page',
      //   iconOnly: true,
      //   iconProps: { iconName: 'ChevronLeftMed' },
      //   onClick:  ()=>{ previousPage() } 
      // },
      {
        key: 'showChatMessages',
        text: 'Show Chat Messages',
        iconOnly: true,
        iconProps: { iconName: 'DrillExpand' },
        onClick:  ()=>{ toggleShowChatMessages(); } 
      },
      // {
      //   key: 'nextPage',
      //   text: 'Next Page',
      //   iconOnly: true,
      //   iconProps: { iconName: 'ChevronRightMed' },
      //   onClick:  ()=>{ nextPage(); } 
      // }    

  
    ];
    
    const renderChatBar=()=>{
      log.info(`renderChatBar @ Chat`);
      return (
              <div style={chatStyle()} >              
              <CommandBar
                      items={_items}
                      farItems={_farItems}
                    />
              </div>
              );  
    };

   const renderChatMessages = ( accessToken ) => {
      log.info(`renderChatMessages @ Chat`);
       return (
            showChatMessages ? <ChatMessagesContainer 
                            chatId =  { chatId } 
                            accessToken = { accessToken }
                            pageNumber = { pageNumber }
                            /> : '' 
              )       
   }
  
    return (
    <>
      {renderChatBar()}
      {renderChatMessages( accessToken )} 
    </>
  )

}

